<template>
    <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="旧密码" prop="old_password">
            <el-input v-model="form.old_password" placeholder="请输入当前账户的密码"/>
        </el-form-item>
        <el-form-item label="新密码" prop="new_password">
            <el-input v-model="form.new_password" placeholder="请输入您要设置的新密码"/>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirm_password">
            <el-input v-model="form.confirm_password" placeholder="请再次输入您的新密码"/>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" :loading="loading" @click="submit('form')">修改密码</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
import axios from '@/axios'

export default {
    data() {
        return {
            loading: false,
            rules: {
                old_password: [
                    {required: true, message: '请输入当前旧密码。'}
                ],
                new_password: [
                    {required: true, message: '请输入当前新密码。'}
                ],
                confirm_password: [
                    {required: true, message: '请输入当前确认密码。'}
                ]
            },
            form: {
                old_password: '',
                new_password: '',
                confirm_password: ''
            }
        }
    },
    created() {
    },
    methods: {
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true
                    axios({
                        url: 'user/account/change-password',
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        this.loading = false
                        if (e.data.code === 0) {
                            this.$alert(e.data.msg, '提示', {
                                callback: action => {
                                    if (action === 'confirm') {
                                        this.$store.dispatch('userLogout')
                                        this.$router.push('/passport/login', e => {
                                            this.$router.go(0)
                                        })
                                    }
                                }
                            })
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    })
                } else {
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
